module.exports = __webpack_public_path__ + "media/images/flags/16/Cocos-Keeling-Islands-412f0c0a69a7c38b279a145507d09707.png";